import { render, staticRenderFns } from "./FieldTextDetail.vue?vue&type=template&id=f3d1ad5a&scoped=true"
import script from "./FieldTextDetail.vue?vue&type=script&lang=js"
export * from "./FieldTextDetail.vue?vue&type=script&lang=js"
import style0 from "./FieldTextDetail.vue?vue&type=style&index=0&id=f3d1ad5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d1ad5a",
  null
  
)

export default component.exports